import api from "../index";

export const GetEmailDetailApi = (params) => api.get(`Marketing/Get-Send-Email-Detail?${params}`);
export const SendMarketingEmailApi = (data) => api.post('Marketing/Send-Marketing-Email', data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const GetSendEmailUserDetailApi = (templateId, params = '') => {
  const query = params ? `?${params}` : '';
  return api.get(`Marketing/template-details/${templateId}${query}`);
};
